import { gql } from "@grandvisionhq/graphql";
import { pickupPoint } from "../../../fragments/operations/fragments/pickup-point.js";
const PICKUP_POINTS_BY_POSTAL_CODE = gql`
  query PickupPointsByPostalCode(
    $postalCodeInput: PickupPointsByPostalCodeInput!
    $shippingDate: Date
  ) {
    pickupPointsByPostalCode(postalCodeInput: $postalCodeInput, shippingDate: $shippingDate) {
      ...PickupPoint
    }
  }
  ${pickupPoint}
`;
export {
  PICKUP_POINTS_BY_POSTAL_CODE
};
//# sourceMappingURL=pickup-points-by-postal-code.js.map
